import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { to: "#" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Btn Dropdown one", -1)
const _hoisted_3 = { to: "#" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Btn Dropdown two", -1)
const _hoisted_5 = { to: "#" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Btn Dropdown three", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_sdFeatherIcons = _resolveComponent("sdFeatherIcons")!
  const _component_Content = _resolveComponent("Content")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createBlock(_component_a_popover, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    class: "className",
    placement: _ctx.placement,
    title: _ctx.title && _ctx.title,
    trigger: _ctx.action
  }, _createSlots({
    content: _withCtx(() => [
      _createVNode(_component_Content, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content", {}, () => [
            _createElementVNode("a", _hoisted_1, [
              _createVNode(_component_sdFeatherIcons, {
                type: "check",
                size: "16"
              }),
              _hoisted_2
            ]),
            _createElementVNode("a", _hoisted_3, [
              _createVNode(_component_sdFeatherIcons, {
                type: "check",
                size: "16"
              }),
              _hoisted_4
            ]),
            _createElementVNode("a", _hoisted_5, [
              _createVNode(_component_sdFeatherIcons, {
                type: "check",
                size: "16"
              }),
              _hoisted_6
            ])
          ])
        ]),
        _: 3
      })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    (_ctx.title)
      ? {
          name: "title",
          fn: _withCtx(() => [
            _createVNode(_component_Title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "placement", "title", "trigger"]))
}